var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { useCallback, useState } from "react";
import { Button, Box, Flexbox } from "../";
export var Tab = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  height: 28px;\n  margin-top: 4px;\n  border-top-right-radius: 4px;\n  border-top-left-radius: 4px;\n  border-bottom: 0;\n  font-weight: 600;\n  &:hover {\n    ", "\n  }\n"], ["\n  ", "\n  height: 28px;\n  margin-top: 4px;\n  border-top-right-radius: 4px;\n  border-top-left-radius: 4px;\n  border-bottom: 0;\n  font-weight: 600;\n  &:hover {\n    ", "\n  }\n"])), function (_a) {
    var isActive = _a.isActive, theme = _a.theme;
    return isActive
        ? {
            backgroundColor: theme.colors.base,
            color: theme.colors.highlight,
            border: "1px solid ".concat(theme.colors.highlight),
        }
        : {
            backgroundColor: theme.colors.contrast,
            color: theme.colors.link,
        };
}, function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.colors.highlight,
    });
});
var HintWrapper = styled(Flexbox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  column-gap: 4px;\n  ", "\n"], ["\n  column-gap: 4px;\n  ", "\n"])), function (_a) {
    var highlighted = _a.highlighted, theme = _a.theme;
    return highlighted && {
        padding: "4px",
        marginTop: "-4px",
        marginLeft: "-4px",
        position: "relative",
        zIndex: 3000,
        borderRadius: "4px",
        backgroundColor: theme.colors.base,
        boxShadow: "3px 3px 14px ".concat(theme.mode === "light" ? "rgba(0,0,0,0.5)" : "rgba(255,255,255,0.5)"),
    };
});
export var Tabs = function (_a) {
    var _b = _a.defaultValue, defaultValue = _b === void 0 ? 0 : _b, children = _a.children, labels = _a.labels, highlighted = _a.highlighted;
    var _c = useState(defaultValue), value = _c[0], setValue = _c[1];
    var onClick = useCallback(function (event) {
        var index = event.target.dataset.index;
        if (index)
            setValue(parseInt(index));
    }, [setValue]);
    return (_jsxs(_Fragment, { children: [_jsx(HintWrapper, __assign({ highlighted: highlighted }, { children: labels === null || labels === void 0 ? void 0 : labels.map(function (label, index) { return (_jsx(Tab, __assign({ "data-index": index, isActive: index === value, onClick: onClick }, { children: label }), label)); }) })), _jsx(Box, __assign({ px: 5, py: 4, color: "text", bg: "base" }, { children: Array.isArray(children) ? children[value] : children }), value)] }));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Tabs.js.map